<template>
  <div>
    <div v-if="type === `permissions`">You do not have permission to access this page.</div>
    <div v-else>An error has been encountered.</div>
  </div>
</template>

<script>
export default {
  name: "errorPage",
  computed: {
    type() {
      return this.$route.query.type;
    },
  },
};
</script>
